import * as api from '../../../clients/qschecks';

import {Action} from '@ngrx/store';

export const GET_PRUEFPLAN_FILTER = '[QschecksModul] GetPruefplanFilter laden';
export const GET_PRUEFPLAN_FILTER_AUSFUEHREN = '[QschecksModul] GetPruefplanFilter ausführen';
export const GET_PRUEFPLAN_FILTER_ERFOLGREICH = '[QschecksModul] GetPruefplanFilter laden erfolgreich';
export const GET_PRUEFPLAN_FILTER_FEHLER = '[QschecksModul] GetPruefplanFilter Ladefehler';
export const GET_PRUEFPLAN_FILTER_NICHT_AUSGEFUEHRT = '[QschecksModul] GetPruefplanFilter nicht ausgeführt (evtl. Offline)';


export class GetPruefplanFilterAction implements Action {
    readonly type = GET_PRUEFPLAN_FILTER;
        constructor( public pruefplan_id:string , public optPayload: any = null) {}
    }
export class GetPruefplanFilterAusfuehrenAction implements Action {
    readonly type = GET_PRUEFPLAN_FILTER_AUSFUEHREN;
        constructor( public pruefplan_id:string , public optPayload: any = null) {}
    }
export class GetPruefplanFilterErfolgreichAction implements Action {
    readonly type = GET_PRUEFPLAN_FILTER_ERFOLGREICH;
        constructor(public payload: api.FilterOption,  public pruefplan_id:string , public optPayload: any = null) {}
    }
export class GetPruefplanFilterFehlerAction implements Action {
    readonly type = GET_PRUEFPLAN_FILTER_FEHLER;
        constructor(public payload: any,  public pruefplan_id:string , public optPayload: any = null) {}
    }
export class GetPruefplanFilterNichtAusgefuehrtAction implements Action {
    readonly type = GET_PRUEFPLAN_FILTER_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type QschecksQueryPruefplanFilterActions =
    GetPruefplanFilterAction
    | GetPruefplanFilterAusfuehrenAction
    | GetPruefplanFilterErfolgreichAction
    | GetPruefplanFilterFehlerAction
    | GetPruefplanFilterNichtAusgefuehrtAction
    ;
